import axios from "axios";


export const saveProductData = (token, productData) => async (dispatch) => {
  try {
    dispatch({ type: "ADD_PRODUCT_PENDING" });

    const response = await axios.post(`/api/supplier/create-supplier-product`, productData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
    });

    dispatch({
      type: "ADD_PRODUCT_FULFILLED",
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: "ADD_PRODUCT_REJECTED",
      payload: error.response,
    });
  }
};
export const getProductList = (token, limit = 10, page = 1, search = "", sort = "desc") =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_PRODUCTLIST_PENDING" });

      const response = await axios.get(
        `/api/supplier/supplier-product`,
        {
          params: {
            paginate: limit,
            page: page,
            search: search,
            sort: sort,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_PRODUCTLIST_FULFILLED",
        payload: response.data?.supplierProducts
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_PRODUCTLIST_REJECTED",
        payload: error.response,
      });
    }
  };

export const getProductById = (token, productId) => async (dispatch) => {
  try {
    dispatch({ type: "GET_PRODUCTLISTBYID_PENDING" });

    const response = await axios.get(`/api/supplier/get-product-ById/${productId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    dispatch({
      type: "GET_PRODUCTLISTBYID_FULFILLED",
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: "GET_PRODUCTLISTBYID_REJECTED",
      payload: error.response,
    });
  }
};

export const updateProductData = (token, productData, productId) => async (dispatch) => {
  try {
    dispatch({ type: "UPDATE_PRODUCT_PENDING" });

    const response = await axios.post(`/api/supplier/update-supplier-product/${productId}`, productData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
    });

    dispatch({
      type: "UPDATE_PRODUCT_FULFILLED",
      payload: response.data,
    });
  } catch (error) {
    console.log(error);
    dispatch({
      type: "UPDATE_PRODUCT_REJECTED",
      payload: error.response,
    });
  }
};
export const deleteProduct = (token, productId) => async (dispatch) => {
  try {
    dispatch({ type: "DELETE_PRODUCT_PENDING" });

    const response = await axios.delete(`/api/supplier/delete-supplier-product/${productId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    dispatch({
      type: "DELETE_PRODUCT_FULFILLED",
      payload: response.data,
    });
  } catch (error) {
    console.log(error);
    dispatch({
      type: "DELETE_PRODUCT_REJECTED",
      payload: error.response,
    });
  }
};

export const getSupplierDashboard = (token, productId) => async (dispatch) => {
  try {
    dispatch({ type: "DASHBOARD_PENDING" });
    const response = await axios.get(`/api/supplier/get-dashboard`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch({
      type: "DASHBOARD_FULFILLED",
      payload: response.data,
    });
  } catch (error) {
    console.log(error);
    dispatch({
      type: "DASHBOARD_FAILED",
      payload: error.response,
    });
  }
};